import { render, staticRenderFns } from "./Sitemap.vue?vue&type=template&id=438c6d2e"
import script from "./Sitemap.vue?vue&type=script&lang=js"
export * from "./Sitemap.vue?vue&type=script&lang=js"
import style0 from "./Sitemap.vue?vue&type=style&index=0&id=438c6d2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports